import { Bold, Italic, Strikethrough, Underline } from 'lucide-react'
import type { FloatingFormatToolbarItem } from '@/components/editor/FloatingToolbar'

export const DEFAULT_FORMAT_TOOLBAR_ITEMS: Array<FloatingFormatToolbarItem> = [
  { format: 'bold', label: 'Bold', Icon: Bold },
  { format: 'italic', label: 'Italic', Icon: Italic },
  { format: 'underline', label: 'Underline', Icon: Underline },
  { format: 'strikethrough', label: 'Strike', Icon: Strikethrough },
]
